
const newModel = () => {
    return {
        tramXangId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        tenPhuongXa: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        gioMoCua: null,
        congTy: null,
        dungTich: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null

    }
}

const newFEModel = () => {
    return {
        tramXangId: null,
        ten: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        gioMoCua: null,
        congTy: null,
        dungTich: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        tramXangId: item.tramXangId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        tenPhuongXa: item.tenPhuongXa,
        phuongXaId: item.phuongXaId,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        gioMoCua: item.gioMoCua,
        congTy: item.congTy,
        dungTich: item.dungTich,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocDateUpdated: item.iocDateUpdated,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        tramXangId: item.tramXangId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        tenPhuongXa: item.tenPhuongXa,
        phuongXaId: item.phuongXaId,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        gioMoCua: item.gioMoCua,
        congTy: item.congTy,
        dungTich: item.dungTich,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        phuongXaId: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        ten: item.ten,
        phuongXaId: item.phuongXaId,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        tramXangId: null,
        ten: null,
        phuongXaId: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        gioMoCua: null,
        congTy: null,
        stt: null,
        dungTich: null,
        ghiChu: null,
        enabled: null,
    }
}

export const tramXangModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


